module.exports = __webpack_public_path__ + "img/karve.9c8cf531.png";